var veratadModal;

$(function(){

  function checkDob(){
    var cFnamez = $("#c-fname").val();
    var cLnamez = $("#c-lname").val();
    var cAdd = $("#c-address").val();
    var cZip = $("#c-zip").val();
    var CCity = $("#c-city").val();
    var cState = $("#c-state").val();
    var dobCandian = $("#dob-canadan").val().replace('/','');
    dobCandian = dobCandian.replace('/','');

    var values = {
      "email": veratadEmail + Math.ceil(Math.random() * 100000) + "@veratad.com", // This field is required to identify existing customers.
      "first_name": cFnamez,
      "last_name": cLnamez,
      "address": cAdd,
      "city": CCity,
      "state": cState,
      "zip": cZip,
      "dob": dobCandian, // This field must match the following format: YYYYMMDD. This field is also required
      "reference": cID
    };
    return values;

  }

  $('#veratad-modal').click(function(e) {
    var values = checkDob();
    if(values.first_name == "" || values.dob == "" || values.last_name == "" || values.city == "" || values.address == "" || values.zip == "" || values.state == ""){
      alert("Please complete all fields to continue");
      return false;
    }else{
      veratadModal.open();
    }
  });


  var values = checkDob();
  veratadModal = new veratad.modal({
    site: "black-buffalo", // veratad will provide your site name for identification.
    review: true, // set to true or false. When true it will trigger a Veratad manual review upon scan failure.
    dcams_plus: true, //set to true if you want the document to be auto scanned or false if you just want it to be uploaded
    language: "en", //if empty English will be the default. Place here the language code to translate for your user. 
    region: "Canada", //set the default region if empty United States will be used, Values = United States, Canada, Asia, Australia, Africa, Europe, Oceania, South America
    region_select: true, //set to true if you want to allow the user to change their region or false to only allow documents from the default region value. If dcams_plus is false the user will not have to select their region it is only for scanning.
    rules: "DCAMS5_0_RuleSet_NAME_DOB", //check out api.veratad.com for more rule sets
    age: "21+", //place the age you want to check here
    fn: values.first_name, //customer first name
    ln: values.last_name, //customer last name
    addr: values.address, //customer street address
    city: values.city, //customer city
    state: values.state, //customer state
    zip: values.zip, //customer zip code
    dob: values.dob, //required - Customer Date of birth. YYYYMMDD format only.
    email: values.email, //required - customer email address. This is used for tracking the user.
    onOpen: function() {
      // console.log('Veratad modal open');
    },
    onClose: function() {
      // console.log('Veratad modal closed');
      veratadModal.close();
    },
    onSuccess: function() {
      //this is just an example. Handle the customer in your own frontend flow. if dcams_plus is false then this callback will occur but this DOES NOT mean the document has been verified only that it has been successfully uploaded in that case.
      //console.log('Document Verified.');
      alert('Document Verified.');
      $.ajax({ 
        type: "GET",  
        url: appsdomain + "/canada-tag-verified.php?cid=" + cid + "&email=" + cEmail + "&fname=" + cFname + "&lname=" + cLname,
        dataType: 'jsonp',
        jsonp: 'tagVerified',
        async: 'true',
        success: function(data1) {
          // alert(JSON.stringify(data1));
        }
      });
      $('#verify .form').html('<p class="success">Success! We were able to successfully verify your age. If you were in the middle of checking out, <a href="/checkout">please continue</a>!</p>').fadeIn(300);
      veratadModal.close();
    },
    onFailure: function() {
      //this is just an example. Handle the customer in your own frontend flow.
      // console.log('Document Failed Verification.');
      alert('Document Failed Verification.');
      veratadModal.close();
    },
  });
  // veratadModal.open();
});